import React, { useState, useEffect } from "react";
import Icon3 from "../img/7e3a3364e9220ae2e17e651bb33e87f3b45be0e233f888d11a247c4b992e58c2.svg";
import Icon8 from "../img/91bc588ade1240a5398b8c0341f90fc434923f867d4d48a5bd106c641234f93a.png";
import { loginRequest } from '../authConfig';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { callMsGraph } from '../graph';

function UserProfile() {
  const { instance, accounts } = useMsal();
  const [graphData, setGraphData] = useState(null);

  useEffect(() => {
    if (accounts.length > 0) {
      instance
        .acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        })
        .then((response) => {
          callMsGraph(response.accessToken).then((data) => setGraphData(data));
        })
        .catch((error) => console.error("Error fetching profile data:", error));
    }
  }, [accounts, instance]);

  return (
      <button className="flex gap-5 items-center self-stretch my-auto text-neutral-700">
        <div className="flex gap-4 items-start self-stretch my-auto">
          <img
            loading="lazy"
            src={Icon8}
            className="object-contain shrink-0 self-stretch my-auto w-12 aspect-square"
            alt="User profile"
          />
          <div className="flex flex-col text-left">
            <h2 className="text-xl font-semibold">
              {graphData?.displayName || "Richard Wilson"}
            </h2>
            <p className="text-base font-medium">{graphData?.surname || "Manager"}</p>
          </div>
        </div>
      </button>
  );
}

export default UserProfile;